import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion'; 
import ArtGallery from '../components/ArtGallery/ArtGallery';
import TreeLoader from '../components/TreeLoader/TreeLoader';
import PhotoDeck from '../components/PhotoDeck/PhotoDeck';
import { DeckIntro } from '../components/PhotoDeck/PhotoDeck.styles';

const PageContainer = styled(motion.div)`
  min-height: 100vh;
  padding: 3rem 1rem 2rem 1rem; 
  text-align: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Intro = styled.p`
  color: var(--secondary-text);
  max-width: 600px;
  margin: 0 auto 1.5rem auto; 
  font-family: var(--font-body);
  line-height: 1.6;
  font-size: 0.95rem; 
`;


const Art = () => {
  // State to control the loading screen visibility
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 2.5 seconds gives the tree enough time to draw before fading away
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1800);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, []);

  const artPieces = [
    {
      title: "monster portrait", 
      image: "/guash1.jpeg", 
      description: "gouache on wood panel",
      medium: "gouache on wood panel"
    },
    {
      title: "sweven",
      image: "/acrylic_canvas1.jpeg",
      description: "acrylic on canvas",
      medium: "acrylic on canvas"
    },
    {
      title: "king of the world",
      image: "/aura.jpeg",
      description: "acrylic on paper",
      medium: "acrylic on paper"
    },
    {
      title: "blue face",
      image: "/blue_face.jpeg",
      description: "acrylic on paper",
      medium: "acrylic on paper"
    }
  ];

  const photoPieces = [
    {
      title: "guatemala",
      image: "/guat1.JPG", // Replace with your actual paths
      location: "san pedro, guatemala"
    },
    {
      title: "guatemala",
      image: "/guat2.JPG",
      location: "san pedro, guatemala"
    },
    {
      title: "northen lights",
      image: "/idahoaurora.jpg",
      location: "horseshoe bend, idaho"
    },
    {
      title: "idaho sunset",
      image: "/idahosunset.jpg",
      location: "boise, idaho"
    },
    {
      title: "bustling streets",
      image: "/india.jpg",
      location: "sakinaka, india"
    },
    {
      title: "mountain in scotland",
      image: "/scotland2.jpg",
      location: "glencoe, scotland"
    },
    {
      title: "central park",
      image: "/nyc.jpg",
      location: "nyc, ny"
    }
  ];

  return (
    <>
      {/* 1. The Full-Screen Loader Overlay */}
      <AnimatePresence>
        {isLoading && <TreeLoader key="tree-loader" />}
      </AnimatePresence>

      {/* 2. The Actual Page Content (loads instantly underneath the overlay) */}
      <PageContainer
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }}  
        exit={{ opacity: 0 }}
        transition={{ 
          duration: 0.5, 
          ease: [0.4, 0, 0.2, 1] 
        }}
      >
        <Intro>
          a collection of pieces from my fall '25 painting class
        </Intro>
        
        <ArtGallery pieces={artPieces} />
        
        {/* --- NEW PHOTO DECK SECTION --- */}
        <DeckIntro>
          pictures from around the world
        </DeckIntro>
        <PhotoDeck photos={photoPieces} />

      </PageContainer>
    </>
  );
};

export default Art;